import React from 'react'
import './style.css'

export default function AboutUs() {
    return (
        <div className="about-container">
            <h1>เกี่ยวกับเรา</h1>
            <div className="about-box">
                <div className="about-text">
                    <div style={{ color: "#fd0088", fontWeight: "lighter", textAlign: "center" }}>BangkokGift.net</div>
                    <div style={{ color: "#fd0088", fontWeight: "lighter", textAlign: "center" }}>Business Corporate Premiums & Gifts...</div>

                    <div className="about-text-small">
                        <div>
                            หากท่านกำลังมองหาของที่ระลึกชิ้นงามที่สื่อถึงบริษัท “แบงค์คอกกิ๊ฟท์” คือคำตอบและทางเลือกคุณภาพที่คุณมองหา
                            บริษัท แบงค์คอกกิ๊ฟท์ จำกัด เจ้าของเว็บไซต์ Bangkokgift.net เป็นผู้เชี่ยวชาญด้านการผลิต การจำหน่าย และการส่งออกของที่ระลึกของบริษัท โดยมีผลิตภัณฑ์หลากหลายประเภท ไม่ว่าจะเป็นเครื่องหนัง ปากกา นาฬิกา ร่ม ตลอดจนเครื่องประดับ เครื่องใช้ในบ้าน
                            สำหรับท่านที่มองหาของที่ระลึกที่เหมาะสมและสามารถสื่อถึงงตัวบริษัทอยู่ บริษัท ทูบิยอง พร้อมนำเสนอความคิดสร้างสรรค์และรูปแบบไม่ซ้ำใคร เพื่อผลิตของที่ระลึกคุณภาพดีและสวยงามตามที่ท่านต้องการ เป็นการช่วยเสริมภาพลักษณ์ให้แก่บริษัทของท่าน
                            บริษัทและองค์กรใหญ่ๆ หลายแห่งไม่ว่าจะเป็น ไดเนอร์สคลับ ซิตี้แบงค์ เอบีบี เดอะมอลล์กรุ๊ป บิ๊กซี และธนาคารแห่งประเทศไทย ล้วนมอบความไว้วางใจให้บริษัททูบิยองเป็นผู้ผลิตของที่ระลึกสุดพิเศษ
                        </div>
                        <div>
                            หากต้องการของที่ระลึก ของชำร่วย ของพรีเมี่ยม หรือสินค้าพรีเมี่ยม ทุกชนิดทุกดีไซน์ สำหรับบริษัท องค์กร ห้างร้าน หรือออแกไนท์ต่างๆ คำตอบอยู่ที่เพียงปลายนิ้วสัมผัส ท่านสามารถดูข้อมูลทั่วไปเกี่ยวกับผลิตภัณฑ์ของบริษัทได้ทางเว็บไซต์ นอกจากนั้น ยังสามารถสอบถาม หรือแสดงความคิดเห็นได้โดยตรงทางอีเมล์
                            พันธกิจของเราคือ “เราต้องการให้ลูกค้าค้นหาผลิตภัณฑ์ของเราได้สะดวก เพียงแค่เปิดเว็บไซต์จากโต๊ะทำงาน พร้อมทั้งส่งคำถามออนไลน์ได้ด้วย เราเชื่อว่าด้วยวิธีการติดต่อแบบใหม่นี้ จะช่วยให้บริษัทเข้าถึงลูกค้าและมอบบริการที่ดีที่สุดแก่ลูกค้าได้”
                        </div>
                    </div>

                    <div className="about-text-bolder">
                        Looking for the Perfect Corporate Giveaway?<br></br>
                        Bangkokgift Co., Ltd. is the Solution
                    </div>

                    <div className="about-text-small">
                        <div>
                            Established in 1996, We specialize in the manufacturing, the distribution and the export of corporate gift items in a wide range of leather products, pens, watches, umbrellas and housewares.
                            For all those who are looking for the appropriate corporate give-away, Tourbillon Co., Ltd. offers creative ideas and packaging to make the selected gift attractive and personalized to enhance your company's image.
                        </div>
                        <div>
                            Several blue-chip companies such as Diners Club, Citibank, ABB, The Mall Group, Big C and the Bank of Thailand have already entrusted Tourbillon to provide them with their perfect corporate gifts.
                        </div>

                    </div>

                    <div className="about-text-bolder">
                        Business Corporate Premiums & Gifts...
                    </div>

                    <div className="about-text-small">
                        <div>
                            Established in 1993 BangkokGift.net is undoubtedly Thailand’s leading and best known supplier of promotional merchandise. From our base in Bangkok and with our experienced team of over 30 employees we supports and advise customers on all aspects of selecting and procuring the right gift for the right occasion.
                        </div>
                        <div>
                            Securing customer loyalty and maintaining a professional outlook is key to the successful future of any business and BangkoGift.net offers a vast range of top quality personalized gifts, corporate clothing and fashion wear. We can print, embroider, or engrave a multitude of products at very competitive prices incorporating top brands such as, Cacharel, Cerruti 1881, Nina Ricci, Ungaro, Jean-Louis Scherrer and Chrles Jourdan.
                        </div>
                        <div>
                            We take pride in the knowledge and experience we have in the promotional gifts industry and have long standing relationships with our Clients.
                        </div>
                    </div>

                    <div className="about-text-bolder">
                        Advice & Sales.
                    </div>

                    <div className="about-text-small">
                        Taking into consideration factors such as your business sector, your corporate message, and the application of gift you may wish to select, our experienced sales team will guide you and help you make the right choices. Our external Account Managers too are always on hand if you need assistance.
                    </div>

                    <div className="about-text-bolder">
                        Print
                    </div>

                    <div className="about-text-small">
                        BangkokGift.net has the resources to supply virtually any type of promotional item printed with your company details. Using the latest marking equipment our in-house print team can work to the tightest of deadlines and ensure vigilant quality control over the print process.
                    </div>

                    <div className="about-text-bolder">
                        Embroidery
                    </div>

                    <div className="about-text-small">
                        BangkokGift.net has the resources to supply virtually any type of promotional item printed with your company details. Using the latest marking equipment our in-house print team can work to the tightest of deadlines and ensure vigilant quality control over the print process.
                    </div>

                    <div className="about-text-bolder">
                        Manufacturing
                    </div>

                    <div className="about-text-small">
                        To provide the best quality and price BangkokGift.net is proudly associated with leading manufacturers of extensive pallet of corporate items ranging from Umbrellas, Silk-Box to Stationary Items, Key Chain, Pen, Clocks, Watches as well as a wide range of clothing based Gifts such as Shirts, Hats, Towels just to mention a few.
                    </div>

                    <div className="about-text-bolder">
                        Company Philosophy
                    </div>

                    <div className="about-text-small">
                        <div>
                            Our team consists of unique individuals, each with years of experience in his or her particular discipline and with this much expertise we can accomplish a great deal as we share a common goal and our goal is to design and produce the best professional Corporate Gifts possible with outstanding quality at our client’s affordable budget.
                        </div>
                        <div>
                            With your input and our efforts we have a winning combination. We look forward to continuing the development of Corporate Gifts required from you - our valued Customers.
                        </div>
                    </div>

                    <div className="about-text-bolder">
                        BangkokGift.net <br></br>
                        Together we can!
                    </div>


                </div>
            </div>
        </div>
    )
}
